module.exports = __webpack_public_path__ + "media/images/icn-pencil-7251d7db7c68fdc430a67df23b78ff9d.png";